import {
  GetQuestionnaireListActionTypes,
  GET_QUESTIONNAIRE_LIST_FAIL,
  GET_QUESTIONNAIRE_LIST_LOADING,
  GET_QUESTIONNAIRE_LIST_SUCCESS,
  GetQuestionnaireListState,
  GET_QUESTIONNAIRE_LIST_UPDATE_API_MSG,
  GET_QUESTIONNAIRE_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetQuestionnaireListRes } from "./Model";

const initialState: GetQuestionnaireListState = {
  loading: false,
  getQuestionnaireListRes: {} as GetQuestionnaireListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getQuestionnaireListReducer = (
  state = initialState,
  action: GetQuestionnaireListActionTypes
): GetQuestionnaireListState => {
  switch (action.type) {
    case GET_QUESTIONNAIRE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_QUESTIONNAIRE_LIST_SUCCESS:
      return {
        ...state,
        getQuestionnaireListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_QUESTIONNAIRE_LIST_FAIL:
      return {
        ...state,
        getQuestionnaireListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_QUESTIONNAIRE_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getQuestionnaireListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_QUESTIONNAIRE_LIST_UPDATE_API_RES:
      return {
        ...state,
        getQuestionnaireListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
